import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from './layout/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BlogLayoutModule } from './blog-layout/blog-layout.module';
import { CommentComponentsModule } from './components/components.module';
import { CookieBannerComponent } from './shared/components/cookie-banner/cookie-banner.component';
import { AuthService } from './shared/auth/auth.service';
import { UserService } from './shared/auth/user.service';
import { CardPaymentModule } from './pages/card-payment/card-payment/card-payment.module';
import { CardPaymentSuccessModule } from './pages/card-payment/card-payment-success/card-payment-success.module';
import { CardPaymentCancelModule } from './pages/card-payment/card-payment-cancel/card-payment-cancel.module';
//import { CardPaymentDirectModule } from './pages/card-payment/card-payment-direct/card-payment-direct.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

console.log('App module loaded, card payment components will be initialized');

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule,
    MatSelectModule,
    MatInputModule,
    MatRadioModule,
    MatMenuModule,
    MatIconModule,
    MatSnackBarModule,
    AppRoutingModule,
    LayoutModule,
    BlogLayoutModule,
    CommentComponentsModule,
    CardPaymentModule,
    CardPaymentSuccessModule,
    CardPaymentCancelModule,
    //CardPaymentDirectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    })
  ],
  declarations: [
    AppComponent,
    CookieBannerComponent
  ],

  providers: [
    AuthService,
    UserService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    console.log('AppModule initialized, all payment components should be available');
  }
}
